import { createContext } from 'use-context-selector';
import { notImplemented } from 'utils/notImplemented';
import { LoadedCvsContextProps } from './LoadedCvsContext.types';

export const loadedCvsContextInitialProps: LoadedCvsContextProps = {
  requestCvRender: notImplemented,
};

export const LoadedCvsContext = createContext(loadedCvsContextInitialProps);
